import { z } from "zod";
export const DocumentationPageContentBackup = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    documentationPageId: z.string(),
    documentationPageName: z.string(),
    storagePath: z.string(),
});
